import TimelineBadge from './timeline-badge'

export default TimelineBadge
